import React from 'react';
import { get } from 'lodash';
import { Translate } from 'core/translate';
import { combineClassNames } from 'core/css';

const PackagePricing = ({ option, className }) => {
  const { discountedPriceTotal, msrpDisplay } = option;
  const msrpDisplayText = get(msrpDisplay, 'display', '');
  const msrpDisplayPrice = get(msrpDisplay, 'amount.text', '');

  const priceLine = (
    <div
      className={combineClassNames(
        'package-pricing__price',
        discountedPriceTotal ? 'package-pricing__price--strike' : '',
        className ? `${className}__price--strike` : ''
      )}>
      {msrpDisplayText || msrpDisplayPrice}
    </div>
  );

  const discountPriceLine = discountedPriceTotal ? (
    <div>
      <span className="package-pricing__price-label">
        <Translate value="discounted.price" />
      </span>{' '}
      <span className="package-pricing__price">
        {discountedPriceTotal.text}
      </span>
    </div>
  ) : null;

  return (
    <div className={combineClassNames('package-pricing', className)}>
      {discountPriceLine}
      {priceLine}
    </div>
  );
};

export default PackagePricing;
